import { Box, Flex, Text } from "@chakra-ui/react";
import BarGraph from "../../../components/molecule/Graph/BarGraph";
import LineGraph from "../../../components/molecule/Graph/LineGraph";
import { GraphBulletinInfo } from "../../../types/Graph/GraphBulletinInfo";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";

export const renderGraphs = (
  dataTableGraphs: GraphBulletinInfo[],
  fontSize: string = "md",
  fontWeight: string = "normal",
) => {
  return (
    <Flex wrap="wrap" gap={4}>
      {dataTableGraphs.map((graphData, index) => {
        const { data, graphicInfo } = graphData;
        const graphTitle = graphicInfo.indicator.name;
        if (data.length === 0) {
          return null;
        }

        const processedData = data
          .filter((dataItem: any) => dataItem.value !== null)
          .map((dataItem: any) => ({
            monthYear: dataItem.dataPeriod
              ? `${dataItem.dataPeriod.name.slice(0, 3)} ${dataItem.year}`
              : `${dataItem.year}`,
            value: dataItem.value,
          }));

        const lineName = data.find((dataItem: any) => dataItem.frequency?.name)
          ? data[0]?.frequency.name
          : graphTitle;

        return (
          <Flex
            key={index}
            flex="1 1 calc(33.33% - 16px)"
            gap="5"
            direction="column"
            border={borderStyle}
            borderRadius={borderRadius}
            padding="6"
            backgroundColor="white"
          >
            <Text fontSize={fontSize} fontWeight={fontWeight}>
              {graphTitle}
            </Text>
            <Box width="100%" height={300}>
              {graphicInfo.graphicType.id === 1 ? (
                <LineGraph
                  data={processedData}
                  width="100%"
                  height={300}
                  lineName={lineName}
                  dataProcesed
                />
              ) : graphicInfo.graphicType.id === 2 ? (
                <BarGraph
                  data={processedData}
                  width="100%"
                  height={300}
                  barName={lineName}
                  dataProcesed
                />
              ) : null}
            </Box>
          </Flex>
        );
      })}
    </Flex>
  );
};
